import { useMemo } from 'react';

import { useI18n } from '@change-corgi/core-react/i18n';

import type { ShareAction } from '#src/app/shared/hooks/share';

import type { CommentShareChannel, PartialComment, PartialPetition, ShareConfig } from './types';
import { useCommentAvailableShareActions } from './useCommentAvailableShareActions';

export type { CommentShareChannel, PartialComment, PartialPetition, ShareConfig };

type Result = ModelHookResult<{
	shareActions: ReadonlyArray<ShareAction<CommentShareChannel>>;
	labels: Record<CommentShareChannel, string>;
	a11Labels: Record<CommentShareChannel, string>;
}>;

export function useCommentShares(comment: PartialComment, petition: PartialPetition, config: ShareConfig): Result {
	const { translate } = useI18n();

	return {
		data: {
			shareActions: useCommentAvailableShareActions(comment, petition, config),
			labels: useMemo(
				() => ({
					facebook: translate('fe.pages.petition_update.facebook_button'),
					twitter: translate('fe.components.petition_share.tweet'),
				}),
				[translate],
			),
			a11Labels: useMemo(
				() => ({
					facebook: translate('corgi.petition.details.comments.actions.share.facebook_a11y', {
						author: comment.user.displayName,
						date: comment.createdAtLocalized,
					}),
					twitter: translate('corgi.petition.details.comments.actions.share.twitter_a11y', {
						author: comment.user.displayName,
						date: comment.createdAtLocalized,
					}),
				}),
				[translate, comment],
			),
		},
	};
}
